export function setScrollbarWidthOnDocument() {
    const docElement = document.documentElement;
    const scrollbarWidthBefore = window.innerWidth - docElement.clientWidth;
    if (scrollbarWidthBefore > 0) {
        const scrollbarWidthAfter = docElement.clientWidth - docElement.offsetWidth;
        const scrollbarWidth = scrollbarWidthBefore - scrollbarWidthAfter;
        docElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
    }
}
//# sourceMappingURL=setScrollbarWidthOnDocument.js.map